import { Pipe, PipeTransform } from '@angular/core';
import {
	AlertInstantSource,
	resolveAlertInstant,
} from '../util/resolve-instant';

/** Resuelve el instante de una alerta (`alert_at` o legacy). */
@Pipe({
	name: 'alertInstant',
	standalone: false,
})
export class AlertInstantPipe implements PipeTransform {
	transform(alert: AlertInstantSource | null | undefined): string | null {
		return resolveAlertInstant(alert);
	}
}
